<main class="min-w-full h-full">
  <router-outlet
    #outlet="outlet"
    (activate)="onRouteChange(outlet)"
  ></router-outlet>
</main>
